import themeColors from '@/assets/theme/colors'
import { borderBottom } from '@mui/system'

const classes = {
  mainDiv: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 25px 10px 25px',
    height: 'auto'
  },
  link: {
    color: themeColors.info.main,
    '&:hover': {
      color: themeColors.info.lightest
    }
  },
  divider: {
    width: 450,
    height: 1,
    borderBottom: '1px solid #ddd',
    marginBottom: '1rem'
  }
}

export default classes
